/**
 * Single source of truth for the "install the Ano CLI credentials on next
 * workspace entry" handoff flag.
 *
 * Written by the "Connect your agent" onboarding overlay right after the user
 * installs the Ano CLI (or marks that step done), and read + cleared by
 * `apps/desktop/src/components/app/use-cli-credentials-install.ts` once
 * `~/.config/ano/credentials.json` has actually been written. Keeping the key
 * + writer here means the writer and reader can never drift on the literal.
 */
export const ANO_CLI_PENDING_FLAG = "ano-cli-creds-pending";

/**
 * Flag the desktop renderer to install the CLI credentials the next time the
 * user enters a workspace. Set both when the user sends the install command to
 * the shell AND when they mark the step done without running it, so either way
 * the creds land once they navigate into a workspace context.
 */
export function markCliCredsPending(): void {
  try {
    localStorage.setItem(ANO_CLI_PENDING_FLAG, "true");
  } catch {
    // localStorage unavailable (Safari private mode / SSR) — non-fatal.
  }
}
